(() => {
  if (customElements.get('lemurea-category-mosaic')) return;
  customElements.define('lemurea-category-mosaic', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-category-grid]');
      this.cards = [...this.querySelectorAll('[data-category-item]')];
      this.controls = this.querySelector('[data-category-controls]');
      if (!this.grid || this.cards.length < 2 || !this.controls) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.previous = this.querySelector('[data-category-previous]');
      this.next = this.querySelector('[data-category-next]');
      this.counter = this.querySelector('[data-category-counter]');
      this.counterTemplate = this.counter.dataset.categoryCounterFormat;
      this.mobile = matchMedia('(max-width: 900px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.previous.addEventListener('click', () => this.go(this.current() - 1), { signal });
      this.next.addEventListener('click', () => this.go(this.current() + 1), { signal });
      this.grid.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      this.grid.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.altKey || event.ctrlKey || event.metaKey) return;
        const targets = { ArrowLeft: this.current() - 1, ArrowRight: this.current() + 1, Home: 0, End: this.cards.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.go(targets[event.key]);
      }, { signal });
      this.resize = new ResizeObserver(() => this.schedule());
      this.resize.observe(this.grid);
      if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        const i = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (i >= 0 && this.mobile.matches) this.go(i, true);
      }, { signal });
      this.controls.hidden = false;
      this.update();
    }
    current() {
      return this.cards.reduce((best, card, i) => Math.abs(card.offsetLeft - this.grid.scrollLeft) < Math.abs(this.cards[best].offsetLeft - this.grid.scrollLeft) ? i : best, 0);
    }
    go(index, instant = false) {
      const i = Math.max(0, Math.min(this.cards.length - 1, index));
      this.grid.scrollTo({ left: this.cards[i].offsetLeft, behavior: instant || this.reduced.matches ? 'instant' : 'smooth' });
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      const i = this.current();
      this.previous.disabled = i === 0;
      this.next.disabled = i === this.cards.length - 1;
      this.counter.textContent = this.counterTemplate.replace('__number__', String(i + 1));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
})();
